import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { FormatPrice } from 'utils/format';

import { withFormikField, getFormikError } from 'utils/formik';

import { Spacer, Flexer, Checkbox, Field } from '@ontruck/orc';

import {
  StyledFirstColumn,
  StyledExtraContainer,
  StyledFieldWrapper,
  StyledHelpText,
} from './styled';

import {
  INSURANCE_EXTRA,
  INSURANCE_FIELD,
  EXTRAS_FIELD,
  SHIPMENTS_FIELD,
} from 'modules/shipper-order/Form/constants';

// TODO move to backend
const getInsurancePrice = (insured_for) => {
  const insurancePrice = 0.0015 * (Number(insured_for) || 0);
  return insurancePrice > 0 && insurancePrice < 15 ? 15 : insurancePrice;
};

const t = {
  label: 'Freight insurance (15% of merchandise value)',
};

const InsuranceExtra = ({ intl, currency, disabled, form }) => {
  const { values, setFieldValue } = form;

  const { shipments } = values;
  const shipment = (shipments || [])[0] || {};

  const currencySymbol = intl.messages.currencies[currency];
  const extras = shipment[EXTRAS_FIELD] || [];
  const isChecked = extras.includes(INSURANCE_EXTRA);
  const value = shipment[INSURANCE_FIELD] || '';

  const toggleInsurance = (e, { value }) => {
    if (value) {
      setFieldValue(SHIPMENTS_FIELD, [
        {
          ...shipment,
          [EXTRAS_FIELD]: extras
            .filter((extra) => extra !== INSURANCE_EXTRA)
            .concat(INSURANCE_EXTRA),
          [INSURANCE_FIELD]: '',
        },
      ]);
      return;
    } else {
      setFieldValue(SHIPMENTS_FIELD, [
        {
          ...shipment,
          [EXTRAS_FIELD]: extras.filter((extra) => extra !== INSURANCE_EXTRA),
          [INSURANCE_FIELD]: undefined,
        },
      ]);
    }
  };

  const handleChange = (e, { value }) =>
    setFieldValue(SHIPMENTS_FIELD, [
      {
        ...shipment,
        [INSURANCE_FIELD]: value,
      },
    ]);

  const error = getFormikError({ field: { name: 'shipments.0.insured_for' }, form });

  return (
    <StyledExtraContainer>
      <Flexer.Parent alignItems="center">
        <StyledFirstColumn p="S">
          <Spacer>
            <Checkbox
              disabled={disabled}
              checked={isChecked}
              label={t.label}
              onChange={toggleInsurance}
            />
          </Spacer>
        </StyledFirstColumn>
        <StyledFieldWrapper pTop="XS" pBottom="XS" visible={isChecked}>
          <Flexer.Parent alignItems="center">
            <Flexer.Child style={{ width: 150 }}>
              <Field
                value={value}
                labelType="hidden"
                width="XS"
                asideRightText={currencySymbol}
                onChange={handleChange}
                invalid={!!error}
              />
            </Flexer.Child>
            <Flexer.Child>
              <StyledHelpText>
                <FormatPrice currency={currency} value={getInsurancePrice(value)} />
              </StyledHelpText>
            </Flexer.Child>
          </Flexer.Parent>
        </StyledFieldWrapper>
      </Flexer.Parent>
    </StyledExtraContainer>
  );
};

InsuranceExtra.propTypes = {
  intl: PropTypes.object,
  currency: PropTypes.string,
  disabled: PropTypes.bool,
  form: PropTypes.object,
};

export default injectIntl(withFormikField(InsuranceExtra));
